export default {
  empresas: [],
  interesses: [],
  unidades: [],
  anexos: [],
  loading: false,
}
